(function () {
  const initProductAccordion = () => {
    const accordionTitles = document.querySelectorAll(
      ".product-about__accordion-title"
    );

    if (accordionTitles.length === 0) {
      return;
    }

    accordionTitles.forEach((title) => {
      // Remove existing event listeners
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);

      newTitle.addEventListener("click", function (e) {
        e.preventDefault();
        const accordionItem = this.closest(".product-about__accordion-item");
        const content = accordionItem.querySelector(
          ".product-about__accordion-content"
        );

        if (!content) {
          return;
        }

        const isActive = this.classList.contains("active");

        if (!isActive) {
          // Close all other accordions
          document
            .querySelectorAll(".product-about__accordion-title.active")
            .forEach((activeTitle) => {
              activeTitle.classList.remove("active");
              const activeContent = activeTitle
                .closest(".product-about__accordion-item")
                .querySelector(".product-about__accordion-content");
              if (activeContent) {
                activeContent.style.display = "none";
                activeContent.style.height = "";
                activeContent.style.overflow = "";
                activeContent.style.transition = "";
              }
            });

          // Open this accordion
          this.classList.add("active");

          // Make sure content is visible for measurement
          content.style.display = "block";
          content.style.visibility = "hidden";
          content.style.height = "auto";

          // Get the natural height
          const height = content.scrollHeight;

          // Reset and animate
          content.style.visibility = "visible";
          content.style.height = "0";
          content.style.overflow = "hidden";
          content.style.transition = "height 0.3s ease";

          // Force reflow
          content.offsetHeight;

          // Animate to full height
          content.style.height = height + "px";

          setTimeout(() => {
            content.style.height = "auto";
            content.style.overflow = "";
          }, 300);
        } else {
          // Close this accordion
          this.classList.remove("active");

          // Get current height
          const height = content.scrollHeight;

          // Smooth slide up animation
          content.style.height = height + "px";
          content.style.overflow = "hidden";
          content.style.transition = "height 0.3s ease";

          // Force reflow
          content.offsetHeight;

          // Animate to 0
          content.style.height = "0";

          setTimeout(() => {
            content.style.display = "none";
            content.style.height = "";
            content.style.overflow = "";
            content.style.transition = "";
          }, 300);
        }
      });
    });
  };

  // Initialize when DOM is ready
  const init = () => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initProductAccordion);
    } else {
      initProductAccordion();
    }
  };

  init();

  // Re-initialize when section is loaded in theme editor
  document.addEventListener("shopify:section:load", function () {
    setTimeout(initProductAccordion, 50);
  });
})();
